import { Info } from "lucide-react";

/**
 * Charakterystyczny znacznik z tooltipem: którym sposobem liczone są kwoty na danym ekranie.
 *   analytical — NOWY podział (grupy zleceń + wolne moce + koszt obsługi), do planowania i decyzji.
 *   official   — dotychczasowe rozliczenie per przedsięwzięcie; podstawa cashflow i finansów.
 * Dzięki temu nigdy nie ma wątpliwości, czy patrzysz na realne pieniądze, czy na widok analityczny.
 */
export function CalcMethodBadge({ kind = "analytical" }: { kind?: "analytical" | "official" }) {
  const analytical = kind === "analytical";
  const pill = analytical
    ? "bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300 ring-1 ring-indigo-200 dark:ring-indigo-800"
    : "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 ring-1 ring-emerald-200 dark:ring-emerald-800";
  return (
    <span className={`group relative inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium cursor-help ${pill}`}>
      <Info size={13} />
      {analytical ? "Widok analityczny — nowy podział" : "Rozliczenie oficjalne — per przedsięwzięcie"}
      <span
        role="tooltip"
        className="pointer-events-none invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity absolute z-30 top-full left-0 mt-2 w-[20rem] p-3 rounded-lg bg-gray-900 text-gray-100 text-xs leading-relaxed shadow-xl normal-case font-normal"
      >
        {analytical ? (
          <>
            Te kwoty liczone są <b>nowym sposobem</b>: koszt pensji dzielony na <b>grupy zleceń</b>,
            z osobno pokazanymi wolnymi mocami ludzi i kosztem obsługi firmy. To widok do planowania i decyzji.
            <span className="block mt-1.5 text-amber-300">
              Uwaga: oficjalne rozliczenie (cashflow, finanse przedsięwzięcia) liczone jest dotychczasowym
              sposobem — per pojedyncze przedsięwzięcie.
            </span>
          </>
        ) : (
          <>
            Te kwoty to <b>dotychczasowe, oficjalne rozliczenie</b> — koszt rozkładany na pojedyncze
            przedsięwzięcia. To podstawa cashflow i finansów.
            <span className="block mt-1.5 text-indigo-300">
              Nowy podział na grupy (z wolnymi mocami) znajdziesz w widokach analitycznych:
              porównanie płac, prognoza, symulacja.
            </span>
          </>
        )}
      </span>
    </span>
  );
}
